module.exports = __webpack_public_path__ + "eb70bad941a3993fcad022612d430788.eot";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Regular-Oblique.eot
// module id = 383
// module chunks = 0